var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 4.804C4 2.522 6.593 1.16 8.444 2.568l9.454 7.197c1.47 1.12 1.47 3.35 0 4.47l-9.454 7.197C6.594 22.84 4 21.48 4 19.197zm3.233-.645C6.743 3.788 6 4.12 6 4.804v14.393c0 .684.744 1.016 1.233.644l9.452-7.195a.82.82 0 0 0 0-1.29z",
    clipRule: "evenodd"
  })));
};
export default SvgPlay;